export const LOAD_MACROS = 'certifications/LOAD_MACROS';
